import { BreadcrumbBar, type BreadcrumbItem } from '@nrg/design-system';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { buildBreadcrumbCrumbs } from '@/modules/topbar/utils/breadcrumb';
import type { AppRoute } from '@/types';

export function AppBreadcrumb() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const items = useMemo<BreadcrumbItem[]>(() => {
    const crumbs = buildBreadcrumbCrumbs({ pathname, t });
    return crumbs.map((crumb) => ({
      label: crumb.label,
      ...(crumb.href !== undefined && {
        href: crumb.href,
        onClick: (event: React.MouseEvent<HTMLAnchorElement>) => {
          event.preventDefault();
          navigate(crumb.href as AppRoute);
        },
      }),
    }));
  }, [pathname, t, navigate]);

  return <BreadcrumbBar items={items} ariaLabel={t('topbar.breadcrumb.ariaLabel')} />;
}
